export default function excerptLimit() {
	const excerpts = document.querySelectorAll('.excerpt-limit');
	excerpts.forEach(el => {
		const maxLength = 140;
		const text = el.textContent.trim();
		if (text.length > maxLength) {
			el.textContent = text.slice(0, maxLength) + '...';
		}
	});
}